<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/10/2021
  -->

<template>
	<qw-button type="primary"
			   class="font-size-4 py-3 px-5"
			   v-bind="$attrs">
		<slot></slot>
	</qw-button>

</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwButtonMain",
	extends: BaseComponent,
	// inheritAttrs: false,
}
</script>

<style lang="scss">

</style>
